import { render, staticRenderFns } from "./BaseEmailField.vue?vue&type=template&id=5327148c"
import script from "./BaseEmailField.vue?vue&type=script&lang=js"
export * from "./BaseEmailField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports